import { CollapsibleCard } from '@yes.technology/react-toolkit'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18n-lite'
import useKanbanContext from 'site/Renderer/components/Kanban/components/KanbanAutoColumns/useKanbanContext'
import { useStatusActions } from 'status/shared'
import useStatusByCode from 'status/shared/hooks/useStatusByCode'
import { useFetchYesObjects } from 'yesObject/shared'
import useYesObject from 'yesObject/shared/hooks/useYesObject'
import { Line, SectionTitle, Title } from './TransportOrderCard.styles'
import CheckpointsSection from './components/CheckpointsSection/CheckpointsSection'
import RouteSection from './components/RouteSection/RouteSection'
import StatusActions from './components/StatusActions'
import { Checkpoint, Route, TransportOrder } from './types'

type TransportOrderCardProps = TransportOrder & {
  ordersToUse?: string[]
}

function TransportOrderCard(transportOrderProps: TransportOrderCardProps) {
  const { t } = useTranslation()

  const { uuid_status: statusCode, ordersToUse } = transportOrderProps

  const { statusActionClassification } = useKanbanContext()

  const classification = useMemo(() => {
    return statusActionClassification?.find(
      (classification) => classification.UUID_OBJECT === statusCode
    )
  }, [statusActionClassification, statusCode])

  const { status } = useStatusByCode({
    objectclassUuid: window.uuidObjectclassTransportorder,
    statusCode
  })

  const { statusActions } = useStatusActions({
    statuses: status ? [status] : []
  })

  const { yesObject: route } = useYesObject<Route>({
    objectUUID: transportOrderProps.route?.[0].uuid || '',
    objectclassUUID: window.uuidObjectclassRoute
  })

  const { yesObjects: checkpoints }: { yesObjects: Checkpoint[] } =
    useFetchYesObjects({
      filterBody: {
        objectclass: window.uuidObjectclassCheckpoint,
        query: {
          $and: [{ 'uuid.des': { $in: route?.checkpoint?.map((c) => c.uuid) } }]
        }
      },
      enabled: !!route?.checkpoint?.[0].uuid
    })

  return (
    <CollapsibleCard
      heightClass='extraSmall'
      headerColor='white'
      centerHeaderElement={<Title>{transportOrderProps.des}</Title>}
      areaLineProps={{
        flexibleHeight: true
      }}
      defaultOpenState={true}
      iconColor='#303032'
    >
      <Line />
      <StatusActions
        statusActions={statusActions}
        transportOrder={transportOrderProps}
        classification={classification}
      />

      <CollapsibleCard
        hierarchyCardLevel={3}
        heightClass='extraSmall'
        style={{ marginBottom: 8 }}
        areaLineProps={{
          style: { backgroundColor: '#004099' }
        }}
        centerHeaderElement={
          <SectionTitle>{t('transport-card.route')}</SectionTitle>
        }
      >
        <RouteSection route={route} checkpoints={checkpoints} />
      </CollapsibleCard>

      <CheckpointsSection checkpoints={checkpoints} ordersToUse={ordersToUse} />
    </CollapsibleCard>
  )
}

export default TransportOrderCard
